<template>
  <div id="contenedor-editar-actividad">
    <v-form ref="editarActividad" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Editar pendiente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-area
          v-model="actividad.descripcion"
          label="Descripción">
          </custom-text-area>
          <v-row>
            <v-col>
              <custom-select
              v-model="actividad.estatus"
              label="Estatus"
              :items="itemsestatus">
              </custom-select>
            </v-col>
            <v-col>
              <custom-date-picker
              v-model="actividad.fechaPlazo"
              label="Fecha Plazo">
              </custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarActividad"
            :disabled="!esformularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixActividades from './mixActividades';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ActualizarActividad',
  mixins: [mixActividades],
  props: {
    actividadEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomSelect,
    CustomTextArea,
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
      esformularioValido: false,
      itemsestatus: ['Abierta', 'Cerrada', 'Cancelada'],
      actividad: {
        descripcion: this.actividadEditar.descripcion,
        estatus: this.actividadEditar.estatus,
        fechaPlazo: this.actividadEditar.fechaPlazo.substring(0, 10),

      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarActividad.reset();
    },
  },

};
</script>

<style>

</style>
